import { useEffect, useRef } from 'react';

const POLL_INTERVAL = 60_000; // 60 saniyede bir kontrol et

const useVersionCheck = () => {
  const knownVersion = useRef(null);

  useEffect(() => {
    let timer = null;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const serverVersion = data?.v;
        if (!serverVersion) return;

        if (knownVersion.current === null) {
          knownVersion.current = serverVersion;
          return;
        }

        if (knownVersion.current !== serverVersion) {
          window.location.reload();
        }
      } catch {
        // network hatası — sessizce geç
      }
    };

    check();
    timer = setInterval(check, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, []);
};

export default useVersionCheck;
